<template>
  <div>
     <h5 class="drawer-sub-title mb-15 mt-0">
      <svgicon name="left_arrow" class="pointer" width="16" height="11"  @click="$emit('closeCartonView')"/>
      <span class="ml-5">{{config && config.name}}</span>
      <div class="f-right">
        <Button type="text" size="mini" @click="downloadDocumentation()">{{$t('INDENT_DOWNLOAD')}}</Button>
<!--        <Button v-if="!isReadOnlyUser" type="text" size="mini" @click="printDocumentation()">{{$t('INDENT_PRINT_SELECTED')}}</Button>-->
        <Button type="text" size="mini" @click="loadCartonDetails()">Refresh</Button>
        <Dropdown type="text" @command="printAllCartons">
          <Button type="text" size="small">
            {{$t('INDENT_PRINT_OPTIONS')}} <span class="el-icon-arrow-down el-icon-right"></span>
          </Button>
          <DropdownMenu divided="true">
            <DropdownItem command="print">{{$t('INDENT_PRINT_SELECTED')}}</DropdownItem>
            <DropdownItem command="printall">{{$t('INDENT_PRINT_ALL')}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </h5>
    <div class="w-400">
      <Input placeholder="Search by Carton ID/Tag" size="mini" class="input-search no-border"
        v-model="query" @input="search">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </Input>
    </div>
     <div class="content-scroll-inner space-top mx-pd-15" style="width:800px">
    <!-- <div class="status-msg my-md" v-if="iscartonLoading">Loading...</div> -->
    <div>
        <div class="status-msg my-md" v-if="!cartonAttachments || !cartonAttachments.length">
          <span>
            <svgicon name="empty-materials" width="250" height="120" :original="true" />
            <p>{{$t('INDENT_NO_DOCUMENT_GENERATED')}}</p>
          </span>
        </div>
        <!-- start of carton level docs -->
        <TagwithAttachment
          v-else
          :documentsList="cartonAttachments"
          :defaultCopies="config.default_copies || 1"
          :selectedDocuments="selectedDocuments"
          :selectedConfig="config"
          @selectDocument="selectSingleDocument"
          @changeCopiesNumber="changeCopies"
          printLevel="carton"
        ></TagwithAttachment>
        <!-- end of carton level docs -->
        <infinite-loading @infinite="loadCartonDetails"  slot="append">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>
<script>
import { uniqBy, orderBy } from 'lodash';
import { mapGetters, mapState } from 'vuex';
import debounce from 'debounce';
import TagwithAttachment from '@/components/orders/TagwithAttachment';
import DocumentCountBadge from '@/components/orders/DocumentCountBadge';

import PrintDocumentsMixin from '@/components/orders/mixins/PrintDocumentsMixin';

export default {
  components: {
    TagwithAttachment,
    DocumentCountBadge,
  },
  props: ['deliveryId', 'orderNumber', 'config', 'isReadOnlyUser', 'currentDepotId'],
  mixins: [PrintDocumentsMixin],
  data() {
    return {
      numeric: null,
      documentsConfig: [],
      indentDocuments: [],
      isLoadingData: false,
      selectedDocuments: [],
      checked: false,
      // documents list
      query: null,
    };
  },
  created() {
    this.selectedDocuments = [];
    this.$store.commit('order/INIT_SUB_DELIVERY_DETAILS');
    // this.loadCartonDetails();
  },
  computed: {
    ...mapGetters({
      cartonPageCount: 'order/subDeliveryPage',
      cartonAttachments: 'order/subDeliveryDetails',
      hasEmpty: 'order/hasEmptySubDeliveryList',
      isCartonLoading: 'order/isSubDeliveryLoading',
    }),
  },
  methods: {
    changeCopies(document, value, index) {
      const details = this.cartonAttachments[index];
      details.default_copies = value;
      this.$store.commit('order/SET_SUB_DELIVERY_DETAIL', { data: details, index });
      this.changeCopiesNumber(document, value);
    },
    async printAllCartons(data) {
      if (data === 'printall') {
        this.selectedDocuments = await this.$store.dispatch('order/printAllDocument',
          { orderNumber: this.orderNumber, documentType: this.config.key, depot: this.currentDepotId });
      }
      this.printDocumentation();
    },
    async loadCartonDetails($state = null) {
      if (!this.isCartonLoading) {
        try {
          const params = {
            printing_level: 'carton',
            page_number: this.cartonPageCount,
            document_type: this.config.key,
            delivery_id: this.deliveryId,
            search: true,
          };
          if (this.query) {
            params.carton_id = this.query;
          }
          const result = await this.$store.dispatch(
            'order/getPackingDocuments',
            params,
          );
          if (!result || result.error) {
            $state.complete();
            this.$errorMessage({ message: this.$t('INDENT_DOCUMENTS_FETCHING_FAILED') });
          } else {
            const resultDocType = result && result.length && result[0].type;
            if (this.config && this.config.subDocumentConfiguration
              && this.config.subDocumentConfiguration.length) {
              this.config = this.config.subDocumentConfiguration &&
                this.config.subDocumentConfiguration.find(_item => _item.key === resultDocType);
            }
          }
        } catch (err) {
          $state.complete();
          this.$errorMessage({ message: this.$t('INDENT_DOCUMENTS_FETCHING_FAILED') });
        }
        if ($state) {
          if (!this.hasEmpty) {
            $state.loaded();
          } else {
            $state.complete();
          }
        }
      }
    },
    search: debounce(function debounceSearch() {
      this.$store.commit('order/SET_SUB_DELIVERY_PAGE', 1);
      this.loadCartonDetails();
    }, 500),
  },
};
</script>
